import React from "react";
import Inquiry from "../components/Inquiry/Inquiry";
import { useNavigate } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
import * as apis from "../apis";

export default function InquiryContainer() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);

  const [options, setOptions] = useState({
    search: "",
    sort: "desc",
    locale: "",
    hasDocument: "",
  });

  const [pageData, setPageData] = useState({
    total: 0,
    currentPage: 1,
    lastPage: 0,
    limit: 10,
    perPage: 5,
  });

  const fetchData = useCallback(async (params = {}) => {
    try {
      const formattedParams = {
        ...params,
        hasDocument:
          params.hasDocument === true
            ? "true"
            : params.hasDocument === false
            ? "false"
            : "",
      };

      const res = await apis.getContacts(formattedParams);

      setData((prev) => ({
        ...prev,
        [formattedParams.page]: res?.data?.data,
      }));
      setPageData((prev) => ({
        ...prev,
        total: res?.data?.pagination?.total || 0,
        lastPage: Math.ceil(res?.data?.pagination?.total / prev.limit) || 1,
        currentPage: formattedParams.page,
      }));
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchData({
      page: pageData.currentPage,
      limit: pageData.limit,
      search: options?.search,
      sort: options?.sort,
      locale: options?.locale,
      hasDocument: options?.hasDocument,
    });
  }, [fetchData, pageData.currentPage, pageData.limit, options]);

  const handlePage = (currentPage) => {
    fetchData({
      page: currentPage,
      limit: pageData.limit,
      search: options?.search,
      sort: options?.sort,
      locale: options?.locale,
      hasDocument: options?.hasDocument,
    });
  };

  // ✅ 옵션 변경 (버튼 클릭 or 검색 입력)
  const handleOptions = (name, value) => {
    setOptions((prev) => ({
      ...prev,
      [name]: value,
    }));

    // 옵션이 바뀔 때마다 1페이지부터 다시 시작
    setPageData((prev) => ({
      ...prev,
      currentPage: 1,
    }));
  };

  const handleDelete = useCallback(
    async (id) => {
      try {
        if (
          window.confirm("문의를 삭제하시겠습니까?\n삭제 후 복구가 어렵습니다.")
        ) {
          await apis.deleteContact(id);
          alert("문의가 삭제되었습니다.");
          fetchData({
            page: pageData.currentPage,
            limit: pageData.limit,
            sort: options?.sort,
            locale: options?.locale,
            search: options?.search,
            hasDocument: options?.hasDocument,
          });
        }
      } catch (error) {
        console.error(error);
        alert(
          error.response?.data?.message || "문의를 삭제하는데 실패 하였습니다."
        );
      }
    },
    [fetchData, pageData.currentPage, pageData.limit, options]
  );

  const handleDetailMove = useCallback(
    (id) => {
      navigate(`/inquiry-detail?id=${id}`);
    },
    [navigate]
  );

  return (
    <Inquiry
      currentPage={pageData.currentPage}
      lastPage={pageData.lastPage}
      perPage={pageData.perPage}
      total={pageData.total}
      data={data}
      options={options}
      handlePage={handlePage}
      handleOptions={handleOptions}
      handleDelete={handleDelete}
      handleDetailMove={handleDetailMove}
    />
  );
}
